import { PRConnect } from "@projectroom/ui-lib";
import Index from "./views/Index.svelte";
import IndexUsecase from "./views/IndexUsecase.svelte";
import ChatGPT from "./views/ChatGPT.svelte";
import IndexPricing from "./views/IndexPricing.svelte";
import IndexEvent from "./views/IndexEvent.svelte";
import IndexEventDetail from "./views/IndexEventDetail.svelte";
import IndexEventPreDetail from "./views/IndexEventPreDetail.svelte";
import IndexAI from "./views/IndexAI.svelte";
import Login from "./views/Login.svelte";
import Join from "./views/Join.svelte";
import JoinAttestation from "./views/JoinAttestation.svelte";
import FindEmail from "./views/FindEmail.svelte";
import FindPassword from "./views/FindPassword.svelte";
import View from "./views/View.svelte";
import Chat from "./views/Chat.svelte";
import ResetPassword from "./views/ResetPassword.svelte";
import PublicLayout from "./views/PublicLayout.svelte";
import IndexLayout from "./views/IndexLayout.svelte";
import LandingPage from "./views/LandingPage.svelte";
import Admin from "./views/admin/Admin.svelte";
import AdminEvent from "./views/admin/AdminEvent.svelte";
import AdminAIChat from "./views/admin/AdminAIChat.svelte";
import AdminAvatalk from "./views/admin/AdminAvatalk.svelte";
import SetToken from "./views/SetToken.svelte";

import Main from "./views/Main.svelte";
import Account from "./views/Account.svelte";
import MainLayout from "./views/MainLayout.svelte";
import AssetLibrary from "./views/AssetLibrary.svelte";

import Builder from "./views/Builder.svelte";
import BuilderLayout from "./views/BuilderLayout.svelte";

import ChatBuilder from "./views/ChatBuilder.svelte";
import ChatBuilderLayout from "./views/ChatBuilderLayout.svelte";

import GameBuilder from "./views/GameBuilder.svelte";
import GameBuilderLayout from "./views/GameBuilderLayout.svelte";
import LauncherBuilder from "./views/LauncherBuilder.svelte";
import LauncherBuilderLayout from "./views/LauncherBuilderLayout.svelte";

import EventBuilder from "./views/EventBuilder.svelte";
import EventBuilderLayout from "./views/EventBuilderLayout.svelte";

import Error from "./views/common/Error.svelte";
import { get } from 'svelte/store';
import { accessToken } from './views/store/auth-store';

const isLogin = () => {
	const jwtAccessToken = get(accessToken);
	if (!jwtAccessToken) {
		return false;
	}
	try {
		const payload = JSON.parse(atob(jwtAccessToken.split('.')[1]));
		const now = Math.floor(Date.now() / 1000);
		if (payload.exp && payload.exp > now) {
		  return true;
		}
	  } catch (e) {
		return false;
	  }
    return false;
}

const routes = [
    {
        name: '/',
        component: Index,
        layout: IndexLayout
    },
	{
        name: '/landing',
        component: LandingPage
    },
    {
        name: '/usecase',
        component: IndexUsecase,
        layout: IndexLayout
    },
	{
        name: '/chatgpt',
        component: ChatGPT,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
	{
		name: '/chat-builder/:chatId',
        component: ChatBuilder,
        layout: ChatBuilderLayout,
		onlyIf: { guard: isLogin, redirect: '/login' }
	},
	{
		// 게임페이지(PAGE_TYPE='GAME') 저작 화면. 봇 빌더(/builder)와 화면이 아예 달라 라우트를 나눈다.
		name: '/game-builder/:botId',
        component: GameBuilder,
        layout: GameBuilderLayout,
		onlyIf: { guard: isLogin, redirect: '/login' }
	},
	{
		// 런처페이지(PAGE_TYPE='LAUNCHER') 저작 화면. 게임과 같은 이유로 라우트를 나눈다
		// — 셸·타일·레시피 저작이라 봇 빌더(/builder)와 화면이 겹치지 않는다.
		name: '/launcher-builder/:botId',
        component: LauncherBuilder,
        layout: LauncherBuilderLayout,
		onlyIf: { guard: isLogin, redirect: '/login' }
	},
    {
        name: '/avatalk-usecase.html',
        component: IndexUsecase,
        layout: IndexLayout
    },
    {
        name: '/pricing',
        component: IndexPricing,
        layout: IndexLayout
    },
    {
        name: '/event',
        component: IndexEvent,
        layout: IndexLayout
    },
    {
        name: '/event/:eventId',
        component: IndexEventDetail,
        layout: IndexLayout
    },
	{
        name: '/event-pre/:eventId',
        component: IndexEventPreDetail,
        layout: IndexLayout
    },
	{
        name: '/character-chat',
        component: IndexAI,
        layout: IndexLayout
    },
    {
        name: '/login',
        component: Login,
        layout: IndexLayout
    },
    {
        name: '/join',
        component: Join,
        layout: IndexLayout
    },
    {
        name: '/join-attestation',
        component: JoinAttestation,
        layout: IndexLayout
    },
    {
        name: '/find-email',
        component: FindEmail,
        layout: IndexLayout
    },
    {
        name: '/find-password',
        component: FindPassword,
        layout: IndexLayout
    },
    {
        name: '/reset-password',
        component: ResetPassword,
        layout: IndexLayout
    },
    {
        name: '/view/:botId',
        component: View
    },
	{
        name: '/chat/:chatId',
        component: Chat
    },
    {
        name: '/main',
        component: Main,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
    {
        name: '/admin',
        component: Admin,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
    {
        name: '/admin-event',
        component: AdminEvent,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
	{
        name: '/admin-avatalk',
        component: AdminAvatalk,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
	{
        name: '/admin-ai-chat',
        component: AdminAIChat,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
    {
        name: '/account',
        component: Account,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
    {
        name: '/assets',
        component: AssetLibrary,
        layout: MainLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
    {
        name: '/builder/:botId',
        component: Builder,
        layout: BuilderLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
    {
        name: '/event-builder/:eventId',
        component: EventBuilder,
        layout: EventBuilderLayout,
        onlyIf: { guard: isLogin, redirect: '/login' }
    },
	{
		name: '/setToken',
        component: SetToken
	},
    {
        name: '404',
        path: '404',
        component: Error,
        layout: PublicLayout
    },
];

export { routes };  